import { MapModel } from '@/types/models';

/**
 * POST /projects/{projectId}/maps/{mapId}:download_map always narrows the exported map
 * down to a polygon, so exporting a whole map means covering it entirely. The margin
 * makes sure that elements touching the border of the map are inside the polygon too.
 */
const WHOLE_MAP_POLYGON_MARGIN = 1;

export interface MapDownloadPoint {
  x: number;
  y: number;
}

export interface MapDownloadBodyRequest {
  converter: string;
  polygon: MapDownloadPoint[];
}

export const getMapDownloadBodyRequest = ({
  converter,
  model,
}: {
  converter: string;
  model: MapModel;
}): MapDownloadBodyRequest => {
  const minX = -WHOLE_MAP_POLYGON_MARGIN;
  const minY = -WHOLE_MAP_POLYGON_MARGIN;
  const maxX = model.width + WHOLE_MAP_POLYGON_MARGIN;
  const maxY = model.height + WHOLE_MAP_POLYGON_MARGIN;

  return {
    converter,
    polygon: [
      { x: minX, y: minY },
      { x: maxX, y: minY },
      { x: maxX, y: maxY },
      { x: minX, y: maxY },
    ],
  };
};
